import { render, staticRenderFns } from "./designateClue400.vue?vue&type=template&id=c8cf32d4&scoped=true"
import script from "./designateClue400.vue?vue&type=script&lang=js"
export * from "./designateClue400.vue?vue&type=script&lang=js"
import style0 from "./designateClue400.vue?vue&type=style&index=0&id=c8cf32d4&prod&scoped=true&lang=scss"
import style1 from "./designateClue400.vue?vue&type=style&index=1&id=c8cf32d4&prod&lang=css"
import style2 from "./designateClue400.vue?vue&type=style&index=2&id=c8cf32d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cf32d4",
  null
  
)

export default component.exports